import { FormControl, FormErrorMessage } from '@chakra-ui/react';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';

import { EPrepImagesSource } from '@/graphql-types/globalTypes';
import { useDraftResources } from '@/hooks/useDraftResources';
import { AlertCircleIcon } from '@/imports/ui/chakra/feather';

import { ImageUploadPreview } from './components/ImageUploadPreview';

export const ImagePreview: React.FC<{
  originalImages?: { imageId: string; imageProxy: string }[];
}> = ({ originalImages }) => {
  const methods = useFormContext();
  const {
    formState: { errors },
    watch,
    setValue,
  } = methods;
  const images = watch('images');

  const originalDescriptiveResources = React.useMemo(
    () => (originalImages ? originalImages : []),
    [originalImages]
  );
  const newDescriptiveResourcesIds = React.useMemo(() => images, [images]);

  const { resourcesSyncedWithDraft } = useDraftResources({
    originalDescriptiveResources: originalDescriptiveResources,
    newDescriptiveResourcesIds: newDescriptiveResourcesIds,
    source: EPrepImagesSource.POST,
  });

  return !!images.length ? (
    // @ts-ignore-next-line: need to upgrade to react-hook-form v6
    <FormControl isInvalid={!!errors.images?.message}>
      <ImageUploadPreview
        resourcesSyncedWithDraft={resourcesSyncedWithDraft}
        onClick={(value: { imageId: string } | { videoId: string }) => {
          setValue(
            'images',
            images.filter(
              (resource: { imageId: string } | { videoId: string }) => {
                const currentId =
                  'imageId' in resource ? resource?.imageId : resource?.videoId;

                return 'imageId' in value
                  ? currentId !== value.imageId
                  : currentId !== value.videoId;
              }
            ),
            { shouldValidate: true }
          );
        }}
      />
      <FormErrorMessage>
        <AlertCircleIcon mr="2" />
        {/* @ts-ignore-next-line: need to upgrade to react-hook-form v6 */}
        {errors.images?.message}
      </FormErrorMessage>
    </FormControl>
  ) : null;
};
